/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { useCallback } from 'react';

import { useDispatch } from 'react-redux';

import { icons } from '../../../../../assets';
import { AccessComponentKeyEnum } from '../../../../../modules/role/constants/guard/guardConstants';
import { loadChartsExpensesAnalyzerAction } from '../../../../../pages/PageExpensesAnalyzer/pageExpensesAnalyzerActions';
import { TTableButtonsGetTranslation } from '../useTableFooterButtons';


const useTableFooterButtonShowOnGraph = (
    getTranslation: TTableButtonsGetTranslation,
) => {
    const dispatch = useDispatch();

    return {
        className: 'table-footer__button btn__show-on-graph',
        dataName: 'showOnGraph',
        icon: icons.starIcon,
        id: AccessComponentKeyEnum.FooterButtonShowOnGraph,
        ...getTranslation(AccessComponentKeyEnum.FooterButtonShowOnGraph),

        onClick: useCallback(() => {
            dispatch(loadChartsExpensesAnalyzerAction());
        }, [dispatch]),
    };
};

export default useTableFooterButtonShowOnGraph;
